<template>
  <div>
    <div
      ref="componente"
      :class="clases"
      data-controller="selector-estructura"

      :data-field-context="namespaceParametros"
      :data-allowed-types="tiposFormateados"
      :data-initial-values="valoresInicialesJson"
      :data-disabled="disabled"

      :data-only-current-year="soloAnnoActual"
      :data-only-academic-groups="soloGruposAcademicos"
      :data-solo-cursos-lomloe="soloCursosLomloe"
      :data-anno-lectivo="idAnnoLectivo"
      :data-check-perms="comprobarPermisos"
      :data-add-grupos-profesor="addGruposProfesor"
      :data-add-grupos-hijos="addGruposHijos"
      v-bind="$attrs"
    >
    </div>
  </div>
</template>

<script>
import { EVENTO_CONTROLLER_CARGADO } from '../apps/cifra/controllers/application_controller';
import ComponentesJQuery from '../mixins/cifra/ComponentesJQuery';

// Este componente de momento usa el que ya existe hecho con Marionette
export default {
  mixins: [ComponentesJQuery],
  props: {
    // ensennanza curso modalidad grupo, etc
    tiposSeleccionables: { type: Array, default: null },
    // Hash con los valores iniciales:
    // :anno_lectivo_id, :ensennanza_id, :nivel_id, :curso_id, :modalidad_id, :grupo_id
    valoresIniciales: { type: Object, default: null },
    // Es el namespace que se enviará, por ejemplo estructura[curso_id]=222.
    // Si es false no envía nada
    namespaceParametros: { type: [String, Boolean], default: 'estructura' },
    soloAnnoActual: { type: Boolean, default: false },
    soloGruposAcademicos: { type: Boolean, default: false },
    soloCursosLomloe: { type: Boolean, default: false },
    idAnnoLectivo: { type: [String, Number], default: null },
    comprobarPermisos: { type: Boolean, default: null },
    addGruposProfesor: { type: Boolean, default: true },
    addGruposHijos: { type: Boolean, default: false },
    ocultarLimpiar: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ['seleccionada'],
  computed: {
    tiposFormateados() {
      return this.tiposSeleccionables?.join(' ');
    },
    clases() {
      return {
        'ocultar-limpiar': this.ocultarLimpiar,
      };
    },
    namespaceFormateado() {
      if (this.namespaceParametros === false) {
        return null;
      }
      return this.namespaceParametros;
    },
    valoresInicialesJson() {
      if (!this.valoresIniciales) {
        return null;
      }
      return JSON.stringify(this.valoresIniciales);
    },
  },
  mounted() {
    this.$refs.componente.addEventListener(EVENTO_CONTROLLER_CARGADO, (e) => {
      this.selectorEstructuraController = e.detail.controller;
      this.selectorEstructuraController.component.on('option:selected', (type, selectedId, path) => {
        this.$emit('seleccionada', { tipo: type, id: selectedId, path });
      });
    });
  },
  methods: {
    seleccionarOpcion(key, value) {
      this.selectorEstructuraController.component.selectOption(key, value);
    },
    getPathSeleccionadoEnHash() {
      return this.selectorEstructuraController.component.getSelectedPathHash();
    },
    limpiarSeleccion() {
      return this.selectorEstructuraController.component.clear();
    }
  },
};
</script>

<style lang="scss" scoped>
.ocultar-limpiar {
  :deep(.cifra-se-clear) {
    display: none;
  }
  :deep(.input-group-btn:last-child) {
    width: 0;
  }
}
</style>
